export interface BaseTableColumns {
    id: number;
    service: string;
    date: string;
}

export class AccountManagerTableColumns implements BaseTableColumns {
    constructor(public id: number, public service: string, public date: string, public sender?: string) {}
}
export class AccountManagerTableWithclosedDateColumns implements BaseTableColumns {
    constructor(public id: number, public service: string, public date: string, public sender?: string,public closedDate?: string) {}
}
export class EmployeeManagenebtRequestsTableColumns {
    constructor(public id: number, public status: string, public service: string, public date: string) {}
}
